<article>
  <section>
    <!-- Loader/Spinner - Solo se muestra cuando NO hay productos visibles -->
    <div class="loader-container" *ngIf="isLoading && products.length === 0">
      <div class="spinner"></div>
     
    </div>

    <!-- Todo List -->
    <div class="todo-list-container" *ngIf="todoList.length > 1">
      <div class="todo-item" 
           *ngFor="let todo of todoList; let i = index; trackBy: trackByTodoId" 
           [class.active]="todo.id === activeTodoId"
           [class.done]="todo.status === 'done'"
           [style.animation-delay]="(i * 0.15) + 's'">
        <span class="todo-circle" 
              [class.tick]="todo.status === 'done'"
              [class.filled-gray]="todo.id === activeTodoId && todo.status !== 'done'"></span>
        <span class="todo-name">{{ todo.name }}</span>
        <span class="todo-quantity" *ngIf="todo.quantity">({{ todo.quantity }})</span>
      </div>
    </div>

    <div class="products-container">
      <app-products #productComponent *ngIf="products.length" [products]="products" [isLoading]="isLoading" (productSelected)="onProductSelected($event)"></app-products>
    </div>
    <app-subtitles #subtitles></app-subtitles>
    
    <!-- Botón Ir a pagar -->
    <button 
      *ngIf="!hasPendingItems() && selectedProducts.length > 0 && !recommendationsEnabled" 
      (click)="goToCart()" 
      class="go-to-cart-btn">
      Ir a pagar
    </button>
  </section>
  <footer>
    <app-speech #speechComponent [actionButton]="speechActionButton" (search)="makeSearch($event)"></app-speech>
  </footer>
</article>
